export default "__VITE_ASSET__CR5La$tC__"